{
  "errorCodes": {
    "COMPLAINT_ALREADY_EXIST": "Жалоба на это объявление уже существует.",
    "ACCOUNT_NAME_IS_ALREADY_TAKEN": "Такое имя учётной записи занято.",
    "INVALID_CONFIRMATION_CODE": "Неправильный код.",
    "TOO_SMALL_IMAGE": "Изображение слишком маленькое.",
    "NOT_FOUND": "Данные не найдены.",
    "ACCOUNT_BLOCKED": "Ваш аккаунт заблокирован или неактивен.",
    "ACCESS_DENIED": "Извините! Доступ запрещён.",
    "ARTICLE_LIMIT_EXCEEDED": "Превышен лимит статей.",
    "EDIT_NOT_ALLOWED": "Редактирование не разрешено.",
    "DISCARD_CHANGES_NOT_ALLOWED": "Отмена изменений не разрешена.",
    "TOO_MANY_ATTEMPTS": "Слишком много попыток.",
    "MODERATION_NOT_ALLOWED": "Модерирование не разрешено.",
    "UNSUITABLE_RELATION": "Неправильная связь.",
    "BOOKING_ALREADY_CANCELED": "Бронирование уже отменено.",
    "COMPANY_LIMIT_EXCEEDED": "Превышен лимит организаторов.",
    "INVALID_PHONE_NUMBER": "Некорректный формат номера.",
    "INVALID_FILE_TYPE": "Неправильный тип файла.",
    "UPLOAD_ALREADY_IN_USE": "Загрузка уже происходит.",
    "ALIEN_UPLOAD": "Загружается что-то «странное».",
    "PROMOTION_ORDER_REVOKE_NOT_ALLOWED": "Отмена заказа на продвижение не разрешена.",
    "PROMOTION_PAYMENT_NOT_ALLOWED": "Оплата на продвижение не разрешена.",
    "INVALID_PROMOTION_ORDER_STATUS": "Неправильный статус заказа на продвижение.",
    "PROMOTION_ORDER_EXISTS": "Заказ на продвижение уже существует.",
    "SPECIALIST_LIMIT_EXCEEDED": "Превышен лимит специалистов.",
    "TREATMENT_LIMIT_EXCEEDED": "Превышен лимит мероприятий.",
    "INACCURATE_LOCATION_EXCEPTION": "Неточное местоположение.",
    "EMPTY_CHANGE_REQUEST": "Нет изменений для сохранения.",
    "COMMENT_LIMIT_EXCEEDED": "Превышено количество комментариев.",
    "ALIEN_DEVICE_UUID": "«Странный» UUID устройства.",
    "ALREADY_SIGNED_IN": "Вы уже авторизованы.",
    "BAD_CREDENTIALS": "Неправильные учетные данные.",
    "INSECURE_PASSWORD": "Небезопасный пароль.",
    "INVALID_CURRENT_PASSWORD": "Неправильный текущий пароль.",
    "BANNED_CONTENT": "Запрещённый контент.",
    "TOO_MANY_UPLOADS": "Слишком много загрузок.",
    "EMAIL_IS_ALREADY_TAKEN": "Электронная почта уже занята.",
    "INVALID_BIRTHDAY": "Неправильная дата рождения.",
    "BOOKING_ALREADY_EXISTS": "Вы уже забронировали данное мероприятие.",
    "REVIEW_LIMIT_EXCEEDED": "Превышен лимит отзывов.",
    "REGION_CHANGE_NOT_ALLOWED": "Изменить регион у этого объявления нельзя.",
    "UNKNOWN_ERROR": "Что-то пошло не так.",
    "UNKNOWN_REGION": "Данный регион не поддерживается",
    "AVATARS_LIST_LOADING_ERROR": "Ошибка загрузки. Обновите страницу",
    "ACCESS_TOKEN_EXPIRED": "Токен доступа истёк или был отозван",
    "ACCESS_TOKEN_INVALID": "Неверный токен доступа"
  },
  "successCodes": {
    "PROFILE_UPDATED": "Профиль был успешно обновлен"
  },
  "validations": {
    "requiredField": "Это поле обязательно для заполнения",
    "contactMethodRequired": "Укажите хотя бы один способ связи",
    "maxOfferNameLength": "Исчерпан лимит в {{maxLength}} символов",
    "maxOfferDescriptionLength": "Исчерпан лимит",
    "minOfferDescriptionLength": "Заполните поле: мин. {{minLength}} символов",
    "categoryRequiredField": "Выберите категорию",
    "nameRequiredField": "Введите имя",
    "newOfferContactWayRequired": "Выберите способ связи",
    "serviceRequired": "Выберите услугу"
  },
  "currency": {
    "uzs": "сум",
    "usd": "у.е."
  },
  "sorting": {
    "title": "Сортировать",
    "titleMobile": "Сортировка",
    "recommended": "Рекомендуемые",
    "new": "Сначала новые",
    "cheap": "Сначала дешевле",
    "expensive": "Сначала дороже"
  },
  "emptySearch": {
    "title": "Мы не нашли то, что вы искали",
    "text": "Попробуйте изменить поисковой запрос",
    "link": "Посмотреть объявления «{{search}}» {{region}}?",
    "feedTitle": "Вам может подойти"
  },
  "emptyCategory": {
    "title": "Сейчас в этом разделе нет объявлений в вашем городе",
    "text": "Поставьте объявление и будьте первым"
  },
  "filters": {
    "drawerDescription": "Выберите нужные фильтры и нажмите «Показать объявления»",
    "modalTitle": "Фильтры",
    "clear": "Сбросить",
    "clearAll": "Сбросить все фильтры",
    "nothingFound": "Ничего не найдено",
    "nothingFoundMessage": "Пожалуйста, поменяйте запрос или выберите опцию из списка",
    "apply": "Показать объявления",
    "applyWithCount": "Показать {{count}} объявлений",
    "showAllOptions": "Все",
    "showMoreOptionsWithCount": "Ещё {{count}}",
    "additional": "Дополнительно",
    "dealConditions": "Условия сделки",
    "urgent": "Срочно. Торг.",
    "courierDelivery": "Доставка курьером",
    "forFree": "Отдам даром",
    "currency": {
      "title": "Валюта",
      "offer": "Из объявления",
      "uzs": "В сумах",
      "usd": "В у.е."
    },
    "price": {
      "title": "Цена",
      "placeholderFrom": "От",
      "placeholderTo": "До",
      "validation": {
        "endGreaterThanStart": "Конечная стоимость должна быть больше начальной",
        "positiveValue": "Введите положительное значение"
      }
    },
    "range": {
      "placeholderFrom": "От",
      "placeholderTo": "До"
    },
    "categories": {
      "title": "Категория",
      "allSelected": "Все",
      "allCategories": "Все категории",
      "filterTitle": "Категории",
      "searchPlaceholder": "Введите название",
      "allCategoryItems": "Все товары категории",
      "emptyTitle": "Ничего не найдено",
      "emptyText": "Пожалуйста, поменяйте запрос или выберите опцию из списка"
    },
    "region": {
      "title": "Где искать"
    }
  },
  "geo": {
    "all": "Все регионы",
    "title": "Выберите город или регион",
    "findMe": "Определить мое местоположение",
    "turnOn": "Включить определение местоположения",
    "notSupported": "Ваш регион не поддерживается",
    "allRegion": "Вся область",
    "indicate": "Укажите название города, региона или выберите из списка",
    "warningTitle": "Нужно снять запрет",
    "warningText": "У вас установлен запрет на определение геолокации. Измените это в настройках браузера и повторите попытку. Это поможет определить ваш адрес.",
    "confirm": {
      "title": "Ваш регион {{region}}?",
      "accept": "Да",
      "change": "Выбрать другой"
    }
  },
  "free": "Бесплатно",
  "price": {
    "from": "от {{price}}",
    "negotiable": "Цена договорная"
  },
  "main": "Главная",
  "search": {
    "filter": "Искать {{name}}",
    "complaint": "Опишите ситуацию",
    "placeholder": "Найти iPhone 15 Pro",
    "searchMobile": "кроссовки Nike",
    "goToCategory": "Перейти в категорию"
  },
  "empty": {
    "title": "Мы ничего не нашли",
    "searchText": "Задайте запрос по-другому или установите более мягкие ограничения",
    "favoriteTitle": "Вы пока ничего не сохранили",
    "favoriteText": "Сохраняйте объявления в избранное, чтобы ничего не упустить",
    "favoriteTitlePublicProfile": "В избранном пусто",
    "favoriteTextPublicProfile": "Войдите и сохраняйте объявления и профили, чтобы ничего не упустить",
    "activeOffersText": "Здесь будут ваши опубликованные объявления",
    "draftOffersText": "Здесь будут черновики ваших объявлений",
    "moderationOffersText": "Здесь будут объявления, требующие вашего внимания после модерации или окончания срока публикации",
    "archiveOffersText": "Здесь будут ваши закрытые объявления",
    "selectText": "Введите запрос по-другому",
    "selectCategoryText": "Пожалуйста, поменяйте запрос или выберите категорию из списка",
    "accountNotFound": "Аккаунт не найден"
  },
  "drafts": {
    "offerWithoutPrice": "Цена не указана",
    "offerWithoutTitle": "Название не указано",
    "offerWithoutLocation": "Адрес не указан"
  },
  "seller": {
    "title": "Мои объявления",
    "bannersTitle": "Полезное для вас",
    "tabs": {
      "active": "Активные",
      "archive": "Архив",
      "draft": "Черновики",
      "moderation": "Ждут действий"
    },
    "offerImageAltText": "Изображение товара"
  },
  "buttons": {
    "complaint": "Пожаловаться",
    "copied": "Скопировано",
    "next": "Далее",
    "back": "Назад",
    "send": "Отправить",
    "close": "Закрыть",
    "closeOffer": "Закрыть объявление",
    "done": "Готово",
    "showMore": "Показать ещё",
    "put": "Поставить",
    "catalog": "Каталог",
    "search": "Поиск",
    "home": "На главную",
    "ok": "Ок",
    "call": "Позвонить",
    "choose": "Выбрать",
    "apply": "Применить",
    "more": "Ещё",
    "showAll": "Показать все",
    "collapse": "Свернуть",
    "hide": "Скрыть",
    "addFavorite": "Добавить в избранное",
    "removeFavorite": "Удалить из избранного",
    "entry": "Войти",
    "entryOrRegister": "Войти или зарегистрироваться",
    "entryOrCreateProfile": "Войти или создать профиль",
    "profile": "Профиль",
    "myProfile": "Мой профиль",
    "myAds": "Мои объявления",
    "favorite": "Избранное",
    "toFavorite": "В избранное",
    "wallet": "Кошелек",
    "settings": "Настройки",
    "exit": "Выйти",
    "extend": "Продлить",
    "extend30": "Продлить на 30 дней",
    "statistics": "Статистика",
    "statisticsOffer": "Статистика объявления",
    "cancel": "Отмена",
    "exitConfirm": "Да, выйти",
    "save": "Сохранить",
    "sell": "Продать",
    "changeProfile": "Изменить профиль",
    "deleteAccount": "Удалить аккаунт",
    "deleteAccountConfirm": "Да, удалить",
    "anotherCategory": "Другая категория",
    "selectCategory": "Выбрать категорию",
    "putAd": "Поставить объявление",
    "edit": "Редактировать",
    "tryAgain": "Попробовать снова",
    "join": "Присоединиться",
    "toAds": "К поиску объявлений",
    "selectAll": "Выбрать все",
    "promotion": "Реклама",
    "buyPromotion": "Купить рекламу",
    "buyMorePromotion": "Купить ещё рекламу",
    "connectedPromotion": "Подключенная реклама",
    "payPromotion": "Оплатить рекламу",
    "payAmount": "Оплатить {{amount}}",
    "publish": "Опубликовать",
    "publishAgain": "Опубликовать повторно",
    "good": "Хорошо",
    "skip": "Пропустить",
    "continue": "Продолжить",
    "gotIt": "Понятно",
    "signIn": "Войти в профиль",
    "reload": "Обновить страницу",
    "favoriteSellerButton": "Вы подписаны",
    "favoriteSubscribeButton": "Подписаться",
    "favoriteUnsubscribeButton": "Отписаться",
    "shareProfile": "Поделиться профилем",
    "translate": "Перевести",
    "showOriginal": "Показать оригинал",
    "chat": "Сообщения",
    "chatBirBir": "Чат BirBir",
    "telegram": "Telegram",
    "trackPrice": "Отслеживать цену",
    "supportService": "Служба поддержки",
    "tryOnceMore": "Попробовать еще раз",
    "verification": "Пройдите проверку ID",
    "passVerification": "Пройти проверку ID",
    "resendAgain": "Отправить снова",
    "remove": "Удалить",
    "contactSupport": "Написать в поддержку",
    "unblock": "Разблокировать",
    "showPhoneNumber": "Показать телефон",
    "goToProfile": "Перейти в профиль",
    "goToOffer": "К объявлению",
    "block": "Заблокировать",
    "download": "Скачать",
    "announcements": "Объявления",
    "birBirForBusiness": "BirBir для бизнеса",
    "myReviews": "Мои отзывы",
    "allCategories": "Все категории",
    "share": "Поделиться",
    "copyLink": "Скопировать ссылку",
    "all": "Все",
    "viewAll": "Смотреть все",
    "clear": "Очистить"
  },
  "tabBar": {
    "search": "Поиск",
    "favorite": "Избранное",
    "catalog": "Каталог",
    "sell": "Продать",
    "messages": "Сообщения",
    "profile": "Профиль"
  },
  "filesUpload": {
    "chooseFiles": "Выберите файлы",
    "annotation": "или перетащите их сюда\n(JPG, PNG, до {{maxMb}} МБ, не ниже 300x300)",
    "dragCaption": "Перетащите файлы сюда",
    "primaryPhoto": "Главная",
    "error": "Ошибка",
    "validationError": "Добавьте хотя бы 1 фото",
    "makePrimary": "Сделать главной",
    "cancel": "Отмена",
    "errors": {
      "TOO_SMALL_IMAGE": "Минимальный размер 300x300 px",
      "FILE_TOO_LARGE": "Файл больше {{maxMb}} МБ. Выберите файл поменьше."
    }
  },
  "appDownload": {
    "features": {
      "catalogTitle": "1 млн +\nобъявлений",
      "catalogText": "Новые и б/у товары, авто, недвижимость и услуги",
      "chatTitle": "Безопасный\nBirBir чат",
      "chatText": "Торгуйтесь и общайтесь, используя автоперевод",
      "sellersTitle": "Проверенные продавцы",
      "sellersText": "Отзывы, модерация объявлений, проверка MyID",
      "appTitle": "Больше возможностей в\u00a0приложении BirBir",
      "sectionLabel": "Возможности BirBir"
    },
    "schemaDescription": "BirBir - новый современный сервис объявлений в Узбекистане",
    "title": "Поставить объявление можно в нашем бесплатном приложении, а ещё там:",
    "footerText": "Скачайте мобильное приложение",
    "discussion": "Можно обсудить сделку в телеграме",
    "observation": "Можно следить за обновлениями",
    "favourite": "Можно сохранять товары в избранном",
    "smartBanner": {
      "title": "BirBir — объявления в Узбекистане",
      "cta": "Скачать",
      "dismissAriaLabel": "Закрыть баннер",
      "ratingAriaLabel": "Рейтинг {{rating}} из {{outOf}}"
    }
  },
  "about": {
    "topBanner": "BirBir — это онлайн-платформа объявлений",
    "bottomBanner": "Присоединяйтесь к BirBir — покупайте и продавайте!",
    "aimTitle": "Наша цель",
    "aimText": "Создать удобное и безопасное пространство для прямых сделок между людьми. BirBir (на узбекском «один-один») — это win-win сделка без посредников, взаимовыгодная для обеих сторон. Наша онлайн-платформа помогает объединить тех, кто ищет, с теми, кто предлагает, в одном месте, задать друг другу необходимые вопросы, получить информацию о товаре, договориться о стоимости и заключить безопасную сделку.",
    "missionTitle": "Наша миссия",
    "missionText": "Создать удобную и безопасную экосистему <br/> для сделок между людьми в Узбекистане.",
    "advantagesTitle": "Почему BirBir?",
    "card1": {
      "title": "Выгодно, легко и безопасно",
      "text": "Покупать и продавать на BirBir различные товары, а также заказывать и предлагать услуги"
    },
    "card2": {
      "title": "Простой и понятный интерфейс",
      "text": "Помогает покупателям быстро находить предложения, а продавцам — размещать объявления и заключать сделки"
    },
    "card3": {
      "title": "В сервисе можно многое",
      "text": "Купить одежду, продать авто или ненужные вещи, сдать или снять квартиру, предложить услуги и помощь"
    },
    "advantage1": {
      "title": "Широкий выбор",
      "text": "Новые и подержанные товары, уникальные находки, услуги в разных категориях и акционные предложения"
    },
    "advantage2": {
      "title": "Прямые сделки",
      "text": "Операции без посредников, дополнительных комиссий и скрытых наценок"
    },
    "advantage3": {
      "title": "Удобство",
      "text": "Быстрый поиск в мобильном приложении, «умные» подборки и оптимизация объявлений с помощью ИИ"
    },
    "advantage4": {
      "title": "Безопасность",
      "text": "Строгая проверка учётных записей, продавцов и объявлений перед публикацией"
    },
    "advantage5": {
      "title": "Личное общение",
      "text": "Возможность обсудить цену, условия оплаты, способы доставки и другие детали с участником сделки"
    },
    "advantage6": {
      "title": "Простота",
      "text": "Платформа, созданная людьми для людей — здесь от поиска до сделки один шаг"
    }
  },
  "favorite": {
    "title": "Избранное",
    "offersTab": "Объявления",
    "followsTab": "Профили",
    "sectionTitle": "Вам может понравиться",
    "loginButton": "Войти в профиль",
    "preview": {
      "viewAll": "Смотреть все"
    }
  },
  "favoriteSeller": {
    "offersCount_one": "{{count}} объявление",
    "offersCount_few": "{{count}} объявления",
    "offersCount_many": "{{count}} объявлений",
    "hasNoOffers": "Нет активных объявлений",
    "deleted": "Профиль удалён",
    "guest": "Гость",
    "showMore": "Показать ещё",
    "showLess": "Показать меньше"
  },
  "sellerSelection": {
    "title": "Объявления продавца",
    "searchPlaceholder": "Найти у продавца",
    "goToCategory": "Перейти в категорию",
    "emptyTitle": "У этого продавца ничего не найдено",
    "emptyText": "Попробуйте изменить запрос или посмотреть другие объявления",
    "recommendationsTitle": "Вам может понравиться"
  },
  "publicSeller": {
    "registered": "На BirBir с {{date}}",
    "offersTitle": "Объявления",
    "activeOffersTitle": "Активные объявления",
    "searchEntry": "Найти у продавца ({{count}})",
    "offersCount_one": "Объявление",
    "offersCount_few": "Объявления",
    "offersCount_many": "Объявлений",
    "followersCount_one": "Подписчик",
    "followersCount_few": "Подписчика",
    "followersCount_many": "Подписчиков",
    "rating": "Рейтинг",
    "noRating": "Нет оценок",
    "noFeed": "У пользователя нет активных \nобъявлений",
    "guest": "Гость",
    "reviewsTitle": "Отзывы о пользователе",
    "reviewTitleMy": "Мои отзывы",
    "reviewTitleBusiness": "Отзывы о магазине",
    "reviewsRate": "Оценить",
    "reviewsAdd": "Оставить отзыв",
    "reviewsEmpty": "Нет отзывов",
    "reviewsCount_one": "{{count}} отзыв",
    "reviewsCount_few": "{{count}} отзыва",
    "reviewsCount_many": "{{count}} отзывов",
    "reviewsSuggestion": "Оставьте отзыв\nо продавце или товаре",
    "reviewsShare": "Поделиться профилем",
    "reviewsEmptyTitle": "Размещайте объявления и делитесь профилем, чтобы получить первые отзывы",
    "reviewsEmptyText": "Отзывы повышают доверие\nи привлекают больше покупателей",
    "becomeSellerTitle": "Начните продавать\nуже сейчас",
    "becomeSellerAction": "Создать объявление"
  },
  "home": {
    "bannersTitle": "Выгодно и полезно",
    "feedTitle": "Интересное",
    "feedTitleRegion": "Интересное {{whereTitle}}",
    "allCategories": "Все категории →"
  },
  "newOffer": {
    "title": "Новое объявление",
    "editTitle": "Редактирование объявления",
    "auth": {
      "title": "Авторизация",
      "hint": "Для публикации объявления войдите в аккаунт"
    },
    "saveDraft": "Сохранить в черновики"
  },
  "menu": {
    "title": "Меню",
    "support": "Поддержка",
    "home": "Главная",
    "blog": "Блог",
    "about": "О нас",
    "regions": "Все регионы",
    "documents": "Правила платформы",
    "categories": "Категории",
    "authors": "Авторы",
    "service": "Услуги"
  },
  "gallery": {
    "title": "{{ current }} из {{ total }}",
    "errorTitle": "Изображение не загрузилось",
    "errorSolving": "Проверьте интернет-соединение",
    "previousImage": "Предыдущее изображение",
    "nextImage": "Следующее изображение"
  },
  "languageTitle": "Выберите язык",
  "errorTitle": "Произошла ошибка",
  "repeatTitle": "Попробуйте еще раз",
  "complaint": {
    "title": "Жалоба на объявление",
    "successTitle": "Спасибо за помощь",
    "successText": "Такие обращения повышают качество объявлений на нашем сервисе."
  },
  "notFound": {
    "title": "Страница не найдена",
    "text": "Но у нас есть много других интересных товаров и категорий"
  },
  "serverError": {
    "title": "Соединение прервано",
    "text": "На сервере произошла ошибка, но мы уже её исправляем. Попробуйте обновить страницу"
  },
  "phone": "Телефон",
  "popular": "Популярно",
  "similarFeed": {
    "title": "Похожие объявления",
    "tooltip": "Ищите похожие товары",
    "empty": "Похожих объявлений пока нет"
  },
  "offer": {
    "number": "№ объявления",
    "publicationTime": "Размещено",
    "views": "Просмотры",
    "features": "Характеристики",
    "description": "Описание",
    "details": "Детали объявления",
    "place": "Место сделки",
    "similar": "Похожее",
    "other": "Объявления продавца",
    "contact": "Связаться с продавцом",
    "deliveryText": "Возможна доставка",
    "landmark": "Ориентир",
    "contactsListTitle": "Контакты",
    "deliveryTitle": "Продавец отметил, \nчто готов организовать доставку",
    "deliveryDescription": "Внимание: Bir Bir не осуществляет доставку товара.\nПожалуйста, не разглашайте свои банковские данные.",
    "guest": "Гость",
    "online": "Онлайн",
    "activeOffersCount_one": "{{count}} активное объявление",
    "activeOffersCount_few": "{{count}} активных объявления",
    "activeOffersCount_many": "{{count}} активных объявлений",
    "onPlatform": "На BirBir с",
    "sellerPhone": "Номер продавца",
    "call": "Связаться",
    "relatedTitle": "Посмотрите другие объявления",
    "relatedText": "Перейдите в эту же категорию или посмотрите другие объявления ниже",
    "relatedLink": "Перейти в категорию",
    "expiredOfferMessage": "Объявление снято с публикации",
    "closed": {
      "showFull": "Смотреть полностью",
      "hideFull": "Свернуть",
      "registered": "Зарегистрирован {{date}}",
      "openGallery": "Открыть галерею фото — {{title}}",
      "categoryCard": {
        "title": "Все объявления категории",
        "subtitle": "Посмотрите все предложения в «{{categoryName}}»",
        "subtitleFallback": "Посмотрите похожие предложения в той же категории",
        "cta": "Перейти в категорию"
      }
    },
    "count_one": "{{count}} объявление",
    "count_few": "{{count}} объявления",
    "count_many": "{{count}} объявлений",
    "translationWarn": "Перевод может быть неточным",
    "askSeller": {
      "title": "Спросите у продавца",
      "optionsLabel": "Варианты вопроса",
      "inputLabel": "Ваш вопрос",
      "sendLabel": "Отправить"
    },
    "offerBid": {
      "customAmountPlaceholder": "Введите желаемую сумму",
      "optionsLabel": "Варианты цены",
      "title": "Предложите свою цену",
      "inputLabel": "Ваша цена",
      "sendLabel": "Отправить"
    },
    "goodPrice": {
      "title": "Почему цена хорошая?",
      "description": "Мы сравнили это объявление с похожими на BirBir: учитывали категорию, модель, характеристики и состояние, указанные продавцом. Цена выглядит выгодной, но детали товара лучше уточнить перед покупкой у продавца."
    }
  },
  "loan": {
    "advertisement": "На правах рекламы",
    "applyButton": "Оформить заявку",
    "period": "мес",
    "loanType": "Микрозайм от Ipoteka Bank"
  },
  "documentsList": {
    "active": {
      "title": "Правила BirBir",
      "subtitle": "Здесь собраны правила и правовая информация, по которым живет BirBir."
    },
    "archive": {
      "title": "Архив юридических документов",
      "subtitle": "Архив содержит предыдущие версии юридических документов платформы"
    }
  },
  "meta": {
    "bulletinBoard": "Доска объявлений",
    "announcements": "Объявления",
    "postAd": "бесплатно поставьте объявление или купите товар. Торг уместен.",
    "bulletinBoardInUzbekistan": "Доска объявлений в Узбекистане",
    "appTitle": "Скачать мобильное приложение BirBir",
    "appDescription": "Скачайте мобильное приложение BirBir. Доступно в App Store, Google Play.",
    "websiteSchema": "Доска объявлений - BirBir. Объявления Узбекистана. Бесплатно поставьте объявление или купите товар. Торг уместен.",
    "aboutTitle": "О компании BirBir",
    "aboutDescription": "Миссия, ценности и новости о компании BirBir. BirBir - узбекский интернет-сервис для размещения объявлений о товарах, недвижимости, вакансиях и резюме на рынке труда, а также услугах.",
    "regionsTitle": "Все регионы Узбекистана",
    "regionsDescription": "На данной странице обозначен перечень городов и населенных пунктов для которых работает сервис объявлений BirBir в Республике Узбекистан.",
    "documentsTitle": "Правила BirBir и юридическая информация",
    "documentsDescription": "Страница с ПРАВИЛАМИ И УСЛОВИЯМИ ИСПОЛЬЗОВАНИЯ ПЛАТФОРМЫ BirBir. Пожалуйста, соблюдайте правила площадки и законы Республики Узбекистан.",
    "categoryTitle": "{{categoryTitle}} {{whereTitle}}",
    "searchTitle": "«{{search}}»: объявления {{whereTitle}}",
    "categoryDescription": "Купить или продать {{categoryLowerTitle}} {{whereTitle}} быстро и по хорошей цене. {{categoryTitle}}: все модели, цена, фото и характеристики на BirBir {{whereTitle}}.",
    "categoryWithFilterTitle": "{{categoryTitle}} {{filterOptionCapitalizedValue}} {{whereTitle}}",
    "categoryWithFilterDescription": "Купить или продать {{categoryLowerTitle}} {{filterOptionCapitalizedValue}} {{whereTitle}} быстро и по хорошей цене. {{categoryTitle}} {{filterOptionCapitalizedValue}}: все модели, цена, фото и характеристики на BirBir {{whereTitle}}.",
    "homeSchemaName": "Объявления {{region}} — BirBir",
    "homeSchemaDescription": "Покупка, продажа и аренда {{region}}: авто, недвижимость, услуги, техника, детские товары и многое другое. Всё на одной площадке — BirBir.",
    "cityPageDefaultTitle": "Объявления {{whereTitle}}",
    "cityPageAllRegionsTitle": "Объявления в Узбекистане",
    "blogTitle": "Блог BirBir: советы, обзоры и новости объявлений в Узбекистане",
    "blogDescription": "Информационный блог BirBir с практическими статьями о товарах, услугах, недвижимости и онлайн-объявлениях в Узбекистане. Полезен покупателям, продавцам и пользователям доски объявлений.",
    "blogTagsTitle": "Теги блога BirBir: темы статей и материалов",
    "blogTagsDescription": "Страница со списком всех тематических тегов блога BirBir. Используется для навигации и удобного поиска материалов по интересующей теме.",
    "blogAuthorsTitle": "Авторы блога BirBir: список авторов, экспертов и опубликованных материалов",
    "blogAuthorsDescription": "Страница со списком авторов блога BirBir и их публикаций. Каждый автор пишет статьи о товарах, услугах, недвижимости и онлайн-объявлениях и лайфхаков о жизни в Узбекистане."
  },
  "assets": {
    "images": {
      "qrCode": "application_qr-code.webp"
    },
    "banners": {
      "main": {
        "image": "main_834_uz.webp",
        "image2x": "main_834_ru_2x.webp",
        "smallImage": "main_430_ru.webp",
        "smallImage2x": "main_430_ru_2x.webp",
        "tabletImage": "main_1024_ru.webp",
        "tabletImage2x": "main_1024_ru_2x.webp",
        "desktopImage": "main_1440_ru.webp",
        "desktopImage2x": "main_1440_ru_2x.webp"
      },
      "appFeatures": {
        "catalog": {
          "lg": "app-banner-catalog-lg.webp",
          "lg2x": "app-banner-catalog-lg_2x.webp",
          "md": "app-banner-catalog-md.webp",
          "md2x": "app-banner-catalog-md_2x.webp",
          "sm": "app-banner-catalog-sm.webp",
          "sm2x": "app-banner-catalog-sm_2x.webp"
        },
        "chat": {
          "lg": "app-banner-chat-lg.webp",
          "lg2x": "app-banner-chat-lg_2x.webp",
          "md": "app-banner-chat-md.webp",
          "md2x": "app-banner-chat-md_2x.webp",
          "sm": "app-banner-chat-sm.webp",
          "sm2x": "app-banner-chat-sm_2x.webp"
        },
        "sellers": {
          "lg": "app-banner-sellers-lg.webp",
          "lg2x": "app-banner-sellers-lg_2x.webp",
          "md": "app-banner-sellers-md.webp",
          "md2x": "app-banner-sellers-md_2x.webp",
          "sm": "app-banner-sellers-sm.webp",
          "sm2x": "app-banner-sellers-sm_2x.webp"
        }
      },
      "blog": {
        "image": "blog-banner.webp",
        "smallImage": "blog-banner-mobile.webp"
      }
    }
  },
  "downloadButtons": {
    "appStoreCaption": "Загрузите в",
    "googlePlayCaption": "Доступно в",
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "chip": {
    "removeAriaLabel": "Удалить {{label}}",
    "notificationDot": "есть уведомление"
  },
  "badge": {
    "delivery": "Доставка",
    "shop": "Магазин",
    "agency": "Агентство",
    "pro": "PRO",
    "idVerified": "ID проверен",
    "idUnverified": "ID не проверен",
    "urgentSale": "Срочно. Торг.",
    "inTwoHours": "За 2 часа",
    "advertisement": "Реклама"
  },
  "sellerModals": {
    "pro": {
      "title": "PRO аккаунт",
      "description": "Эта иконка означает, что пользователь является профессиональным продавцом."
    },
    "verified": {
      "title": "Профиль подтверждён",
      "description": "Эта иконка означает, что профиль подтверждён через сервис MyID."
    }
  },
  "distance": {
    "km": "{{distance}} км"
  },
  "feedCard": {
    "todayAt": "Сегодня, {{time}}"
  },
  "goodPrice": {
    "label": "Хорошая цена"
  },
  "sidebar": {
    "myProfile": "Мой профиль",
    "advertisement": "Мои объявления",
    "favorite": "Избранное",
    "chat": "Сообщения",
    "business": "BirBir для бизнеса",
    "support": "Служба поддержки",
    "language": "Язык ({{language}})",
    "changeLanguage": "Смена языка",
    "aboutUs": "О нас",
    "rules": "Правила площадки",
    "verification": "Пройдите проверку ID",
    "namelessProfileCaption": "Введите имя",
    "lookAtProfile": "Как выглядит мой профиль",
    "loginOrRegister": "Войти или зарегистрироваться"
  },
  "forms": {
    "login": {
      "title": "Войти или создать профиль",
      "description": "По данному номеру покупатели смогут вас найти.\nВы также сможете его использовать для авторизации.",
      "conditions": "Авторизуясь вы соглашаетесь c <policy>политикой обработки персональных данных</policy> и <agreement>пользовательским соглашением</agreement>",
      "requestCode": "Получить код"
    },
    "otp": {
      "title": "Введите код из смс",
      "sentTo": "Отправили на {{phone}}",
      "sentToOnMobile": "Мы направили вам его по номеру\n{{phone}}",
      "requestCode": "Получить код",
      "replyRequest": "Запросить код повторно через {{seconds}} сек"
    },
    "profile": {
      "title": "Изменить профиль",
      "namePlaceholder": "Введите ваше имя",
      "contactPreference": "Предпочтительный способ связи с вами",
      "birBirChat": "Чат BirBir",
      "enabledByDefault": "Включен по умолчанию",
      "phoneCalls": "Звонки по телефону",
      "telegramChat": "Чат в телеграм",
      "telegramPhoneNumber": "По номеру {{phoneNumber}}"
    },
    "verification": {
      "title": "Проверка ID",
      "birthDate": "Дата рождения",
      "passport": "Серия и номер ID или паспорта",
      "passportSeries": "Серия",
      "passportNumber": "Номер",
      "disclaimer": "Нажимая продолжить, вы соглашаетесь с <policy>политикой обработки персональных данных</policy> и <agreement>пользовательским соглашением</agreement>"
    },
    "fragments": {
      "photos": {
        "label": "Фотографии (от 1 до 10)",
        "description": "Перетягивайте фото для изменения порядка",
        "descriptionMobile": "JPG, PNG, до 10 МБ, не ниже 300 × 300"
      },
      "title": {
        "label": "Название",
        "description": "Коротко опишите товар или услугу (не более 50 символов)",
        "placeholder": "Например, кроссовки Nike 42 размера"
      },
      "features": {
        "label": "Характеристики",
        "minValueHint": "Минимальное значение {{minValue}}",
        "maxValueHint": "Максимальное значение {{maxValue}}",
        "betweenMinAndMaxHint": "Значение должно быть от {{valueMin}} до {{valueMax}}",
        "selectPlaceholder": "Введите данные для поиска"
      },
      "category": {
        "label": "Категория",
        "noEditMessage": "Вы не можете изменить категорию при редактировании объявления"
      },
      "conditions": {
        "label": "Условия сделки",
        "free": "Отдам даром",
        "price": {
          "title": {
            "fixed": "Стоимость",
            "negotiable": "Минимальная стоимость"
          },
          "placeholder": {
            "fixed": "Укажите цену",
            "negotiable": "От"
          },
          "error": "Укажите цену",
          "urgent": "Возможен торг"
        }
      },
      "description": {
        "label": "Описание",
        "description": "Например: «Чёрные кроссовки Nike, размер 42. Состояние отличное — носились всего пару раз. Продаю, так как не подошёл размер».",
        "placeholder": "Расскажите о товаре или услуге"
      },
      "location": {
        "label": "Место сделки",
        "description": "Укажите реальное место встречи, чтобы покупателям было удобно спланировать покупку и быстрее с вами связаться",
        "defaultSearch": "Ташкент",
        "address": "Адрес",
        "addressPlaceholder": "Адрес, магазин или метро",
        "addressError": "Укажите адрес",
        "mark": "Ориентир",
        "markPlaceholder": "Например, алайский рынок",
        "courierDelivery": "Могу организовать доставку"
      },
      "contacts": {
        "label": "Контакты",
        "phoneInputLabel": "Телефон",
        "nameInputLabel": "Имя"
      },
      "contactWays": {
        "label": "Способы связи",
        "description": "Необходимо выбрать хотя бы один способ связи"
      }
    }
  },
  "modals": {
    "deleteAccount": {
      "initial": {
        "title": "Удалить аккаунт?",
        "description": "Мы удалим ваши объявления, историю поиска и избранное. Это действие нельзя будет отменить."
      },
      "success": {
        "title": "Ваш аккаунт удален",
        "description": "Мы удалили все ваши публикации и историю взаимодействия с платформой"
      }
    },
    "logout": {
      "title": "Выйти из профиля?",
      "description": "Вы сможете зайти снова\nпо номеру телефона"
    },
    "selectCategory": {
      "title": "Категория",
      "inputPlaceholder": "Найти"
    },
    "ad": {
      "successTitle": "Ваше объявление на проверке",
      "successDescription": "Вы можете найти своё объявление в списке ваших объявлений.",
      "failureDescription": "Объявление не опубликовано, но сохранено в черновиках. Пожалуйста, попробуйте снова."
    },
    "closeOffer": {
      "title": "Укажите причину",
      "description": "Ваше объявление будет снято\nс публикации и попадёт в архив",
      "promotionDescription": "В вашем объявлении подключена реклама.\nОна приостановится и возобновится при\nповторной публикации объявления"
    },
    "promoteOffer": {
      "title": "Сделайте объявление заметнее",
      "footerHint": "Нажимая на кнопку “Оплатить”, вы соглашаетесь с условиями <document>оферты</document>",
      "day_one": "{{count}} день",
      "day_few": "{{count}} дня",
      "day_many": "{{count}} дней"
    },
    "offerPromotions": {
      "title": "Подключённые услуги",
      "offer": "{{title}}: {{price}} за {{duration}}"
    },
    "offerPromotionsPayment": {
      "title": "Реклама оплачена",
      "description": "Подключённые услуги",
      "errorTitle": "Оплата не прошла",
      "errorDescription": "Попробуйте оформить рекламу позже.\nЭто можно сделать в списке ваших объявлений."
    },
    "offerStatistics": {
      "title": "Статистика"
    },
    "downloadApp": {
      "offer": {
        "title": "Скачайте\n приложение BirBir",
        "content": {
          "title": "Продолжайте с удобством — в приложении BirBir",
          "description": "Скачайте приложение, чтобы быстрее отвечать покупателям, пройти идентификацию, получать уведомления об отзывах и отслеживать доставку."
        },
        "image": {
          "phone": "offer_ru.webp"
        }
      },
      "price_track": {
        "title": "Скачайте\n приложение BirBir",
        "content": {
          "title": "Следите за выгодой в приложении BirBir",
          "description": "Мы пришлём уведомление в приложении, когда цена на интересующий вас товар снизится — вы узнаете о скидках и новых поступлениях товаров у любимого продавца в числе первых."
        },
        "image": {
          "phone": "price_tracking_ru.webp",
          "highlight": "price_tracking_helper_ru.webp"
        }
      },
      "delivery": {
        "title": "BirBir Доставка\n в приложении",
        "content": {
          "title": "Оформить доставку можно в приложении BirBir",
          "description": "Скачайте, чтобы оформить заказ с доставкой за 2 часа по Ташкенту и заказывайте товары до двери!"
        },
        "image": {
          "phone": "delivery.webp"
        }
      },
      "review": {
        "title": "Скачайте\n приложение BirBir",
        "content": {
          "title": "Скачайте приложение BirBir, чтобы оставить отзыв.",
          "description": "Оставлять отзывы можно в приложении. Установите его и поделитесь опытом."
        },
        "image": {
          "phone": "download-app-banner_reviews_ru.webp"
        }
      },
      "registration": {
        "title": "Скачайте\n приложение BirBir",
        "content": {
          "title": "Все возможности BirBir — в приложении",
          "description": "Покупайте и продавайте быстрее. Общайтесь с продавцами и пользуйтесь всеми возможностями BirBir в одном приложении"
        },
        "image": {
          "phone": "registration-download-app-ru.webp"
        }
      }
    },
    "suggestVerification": {
      "title": "Станьте проверенным пользователем на BirBir",
      "description": "Проверенные пользователи вызывают больше доверия. Процесс безопасный и займёт всего пару минут.",
      "image": "guard.webp",
      "success": {
        "title": "Проверка ID прошла успешно",
        "description": "Теперь пользователи увидят, что ваш профиль подтвержден"
      },
      "failure": {
        "description": "Мы не смогли подтвердить ваш ID"
      }
    }
  },
  "stats": {
    "adViews": {
      "tooltip": "Количество просмотров вашего объявления",
      "description_one": "{{count}} просмотр вашего объявления",
      "description_few": "{{count}} просмотра вашего объявления",
      "description_many": "{{count}} просмотров вашего объявления"
    },
    "adSaves": {
      "tooltip": "Количество сохранений вашего объявления",
      "description_one": "{{count}} сохранение объявления в избранное",
      "description_few": "{{count}} сохранения объявления в избранное",
      "description_many": "{{count}} сохранений объявления в избранное"
    },
    "contactViews": {
      "tooltip": "Количество просмотров ваших контактов и начатых чатов",
      "description_one": "{{count}} просмотр ваших контактов",
      "description_few": "{{count}} просмотра ваших контактов",
      "description_many": "{{count}} просмотров ваших контактов"
    }
  },
  "regions": {
    "allCategories": "Все категории {{ region }}"
  },
  "chat": {
    "defaultTitle": "Сообщения",
    "userNotFound": "Аккаунт не найден",
    "userBlocked": "Вы заблокировали пользователя.\nОтправка и получение сообщений недоступны.",
    "messagingRestricted": "Пользователь ограничил возможность отправки сообщений.",
    "yourMessage": "Вы:",
    "offerClosed": "Закрыто",
    "inputPlaceholder": "Ваше сообщение",
    "attachments": {
      "camera": "Камера",
      "photo": "Отправить фото",
      "gallery": "Выбрать из галереи",
      "location": "Отправить геолокацию"
    },
    "dialogsPlaceholder": {
      "title": "В чатах BirBir безопаснее",
      "description": "Общаться в чатах BirBir \nудобнее и безопаснее"
    },
    "chatPlaceholder": {
      "title": "Уточните детали у продавца",
      "description": "Пока нет сообщений"
    },
    "userStatus": {
      "online": "Онлайн",
      "recently": "Был(а) недавно"
    },
    "errorMessage": "Не доставлено",
    "unreadMessages": "Непрочитанные сообщения",
    "today": "Сегодня",
    "yesterday": "Вчера",
    "complaint": "Здравствуйте!, хочу пожаловаться на пользователя с uuid: {{uuid}}",
    "blockModalTitle": "Заблокировать пользователя?",
    "blockModalText": "Пользователь не сможет отправлять вам сообщения, видеть ваши  объявления и профиль. Вы всегда можете разблокировать его.",
    "blockConfirm": "Да, заблокировать",
    "autoTranslation": "Автоперевод на русский",
    "appBanner": {
      "title": "Не пропустите новые сообщения",
      "description": "Уведомления доступны в приложении",
      "cta": "Скачать приложение",
      "close": "Закрыть баннер"
    },
    "photo": "Фото",
    "noMessagesInDialog": "Нет сообщений",
    "photoMessage": "Фото",
    "locationMessage": "Геолокация",
    "mapLocation": {
      "title": "Место встречи",
      "viewOnlyTitle": "Предпросмотр геопозиции",
      "geoPosition": "Геопозиция",
      "searchPlaceholder": "Найти в Узбекистане",
      "viewOnMap": "Открыть в Yandex картах"
    },
    "messageUnsupported": "Это сообщение пока нельзя отобразить здесь. Для просмотра скачайте мобильное приложение."
  },
  "blog": {
    "title": "Советы и вдохновение от BirBir",
    "tags": {
      "all": "Все статьи",
      "authorArticles": "Статьи автора",
      "authorTags": "Категории",
      "authorLinks": "Другие публикации"
    },
    "authors": {
      "title": "Авторы",
      "tabHeadingTags": "Категории, в которых публикуется автор",
      "tabHeadingLinks": "Ссылки на материалы автора на сторонних ресурсах",
      "article_one": "{{count}} статья",
      "article_few": "{{count}} статьи",
      "article_many": "{{count}} статей"
    },
    "article": {
      "navigationTitle": "Содержание",
      "similarItems": "Похожие материалы",
      "editedAt": "Обновлено {{date}}",
      "faq": "Популярные вопросы",
      "banner": {
        "title": "Найдите лучшее прямо сейчас",
        "description": "Мы собрали для вас самые интересные товары в одном месте"
      }
    }
  },
  "theme": {
    "system": "Системная",
    "light": "Светлая",
    "dark": "Тёмная"
  },
  "monetization": {
    "meta": {
      "title": "Продавайте быстро на BirBir. Платные услуги",
      "description": "Как быстро продать на BirBir? Используйте платные услуги продвижения объявлений: больше показов, больше просмотров и быстрые продажи."
    },
    "hero": {
      "titlePart1": "Продвигайте свои объявления",
      "titleAccent": "на BirBir",
      "subtitlePart1": "На площадке объявлений Узбекистана с доступом",
      "subtitleBold": "к 1+ миллиону покупателей",
      "cta": "Поставить объявление"
    },
    "services": {
      "title": "Как продвигать объявления и продавать быстрее",
      "subtitle": "У BirBir есть инструменты, которые помогают выделиться в поиске и получить больше просмотров",
      "priceNote": "Стоимость услуг продвижения зависит от категории",
      "maxiCard": {
        "title": "Макси карточка",
        "feature1": "Объявления выше в поиске",
        "feature2": "Бейдж «Premium» и расширенная фото-галерея",
        "feature3": "Прямой доступ к вашим контактам",
        "feature4": "Крупная фотография в мобильной версии и приложении",
        "summary": "Подходит, если объявление нужно выделить"
      },
      "autoUp": {
        "title": "Вверх 4 раза",
        "feature1": "Автоподнятие 4 раза — на 7, 14, 21 и 28 день",
        "feature2": "Объявление поднимается вверх в ленте, как будто только что размещено",
        "summary": "Подходит, если объявление опустилось в поиске"
      },
      "oneUp": {
        "title": "Разовое поднятие",
        "feature1": "Ручное поднятие в любое время",
        "feature2": "Объявление поднимается вверх в ленте, как будто только что размещено",
        "summary": "Подходит, если объявление опустилось в поиске"
      }
    },
    "business": {
      "title": "BirBir для бизнеса",
      "cardTitle": "Проверенный продавец",
      "cardSubtitle": "Для Юридических лиц",
      "feature1": "Бейдж доверия «Магазин» и «Агентство»",
      "feature2": "Персональный бизнес-менеджер",
      "feature3": "Бесплатное подключение",
      "cta": "Оставить заявку",
      "footerLine1": "В приложении могут тестироваться новые форматы продвижения, следите за новостями в наших соцсетях.",
      "footerLine2": "Пакетные решения — в разработке."
    }
  }
}
